import { RadioButton, Typography } from "@king-ict/eupisi-ui/components";
import { Row, Col } from "react-bootstrap";
import { useTranslation } from "react-i18next";

import { OutsideEnrollmentAreaStatus } from "../../../../models/Request";

interface SimpleApprovalRadioGroupProps {
  isEditing: boolean;
  isApproved: boolean;
  status: OutsideEnrollmentAreaStatus;
  onApprovalChange: (isApproved: boolean) => void;
}

export function SimpleApprovalRadioGroup({
  isEditing,
  isApproved,
  status,
  onApprovalChange,
}: SimpleApprovalRadioGroupProps) {
  const { t } = useTranslation();

  const isDisabled =
    !isEditing || status === OutsideEnrollmentAreaStatus.Decision;

  return (
    <>
      <Row>
        <Col md={12}>
          <Typography variant="baseBold">
            {t("suggestedOutsideEnrollmentArea.isApproved")}
          </Typography>
        </Col>
      </Row>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <RadioButton
            ariaLabel={t("common.yes")}
            label={t("common.yes")}
            name="yes"
            checked={isApproved}
            onChange={() => onApprovalChange(true)}
            disabled={isDisabled}
          />
        </Col>
      </Row>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <RadioButton
            ariaLabel={t("common.no")}
            label={t("common.no")}
            checked={!isApproved}
            name="no"
            onChange={() => onApprovalChange(false)}
            disabled={isDisabled}
          />
        </Col>
      </Row>
    </>
  );
}
